import { FC, MouseEvent } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import Icon from 'src/components/Icon';
import * as S from './styles';

const msgs = defineMessages({
  save: { id: 'save_ribbon_save', defaultMessage: 'Save {word}' },
  unsave: { id: 'save_ribbon_unsave', defaultMessage: 'Unsave {word}' },
});

export type { SaveRibbonButtonVariant } from './styles';

interface Props {
  word: string;
  isSaved: boolean;
  onToggle: () => void;
  variant?: S.SaveRibbonButtonVariant;
  className?: string;
}

export const SaveRibbonButton: FC<Props> = ({
  word,
  isSaved,
  onToggle,
  variant = 'inline',
  className,
}) => {
  const intl = useIntl();

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    onToggle();
  };

  return (
    <S.Button
      type="button"
      className={className}
      $variant={variant}
      $isSaved={isSaved}
      aria-label={intl.formatMessage(isSaved ? msgs.unsave : msgs.save, { word })}
      aria-pressed={isSaved}
      onClick={handleClick}
      data-testid="save-ribbon-button"
    >
      <Icon name={isSaved ? 'bookmarkFilled' : 'bookmark'} />
    </S.Button>
  );
};
